import React, { useState, useEffect } from "react";
import Loader from "react-loader-spinner";
import axios from "axios";
import InAppPurchasePopup from "../../popup/inAppPurchasePopup/InAppPurchasePopup";
import { Link } from "react-router-dom";

const Product = () => {
  const [Loading, setLoading] = useState(true);
  const [programList, setProgramList] = useState([]);
  const [modalShow, setModalShow] = useState(false);

  const programPackageData = () => {
    axios
      .get(
        // "http://127.0.0.1:5001/btay-project-1551779459124/us-central1/AY/get/programInAppMapping/programs"
        "https://us-central1-btay-project-1551779459124.cloudfunctions.net/AY/get/programInAppMapping/programs"
      )
      .then((res) => {
        console.log("res", res.data.programs);
        setProgramList(res.data.programs);
        setLoading(false);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    programPackageData();
  }, []);

  if (Loading) {
    return (
      <div className="fp-Container">
        <Loader type="TailSpin" color="#FE5266" height={30} width={30} />
      </div>
    );
  }
  return (
    <div className="ay__programBatchesDisplay ">
      <div className="ay__programBatchesDisplay-header">
        <span>Program</span>

        {/* <button
          onClick={() => {
            setModalShow(true);
          }}
          className="addQuickRead"
        >
          Create Program
        </button> */}
        <Link to={"/appProgram"}>
          <button className="addQuickRead">Create Program</button>
        </Link>
      </div>

      <div className="table-container">
        <table className="table">
          <thead className="table-header">
            <tr>
              <th className="table-cell">Program Id</th>
              <th className="table-cell">Program Name</th>
              <th className="table-cell">Duration</th>
              <th className="table-cell">Package Id</th>
              {/* <th className="table-cell">Action</th> */}
              {/* <th className="table-cell">Edit</th> */}
            </tr>
          </thead>
          <tbody>
            {programList.map((item, index) => (
              <tr
                className={`table-row ${index % 2 === 0 ? "even" : "odd"}`}
                key={index}
                style={{ height: "50px" }}
              >
                <td className="table-cell">{item?.id}</td>
                <td className="table-cell">{item?.name}</td>

                <td className="table-cell">
                  {item?.validity} {item?.validityUnit}
                </td>
                <td className="table-cell">{item?.packageId}</td>

                {/* <td className="table-cell">
                  <div className="quickReadsSwitch batchesSwitchs">
                    <label class="switch">
                      <div
                        className="checkbox_container"
                        onChange={() => {
                          onChangeChecked(teacher);
                        }}
                      >
                        <input type="checkbox" />
                        <span
                          class="slider round"
                          style={
                            item?.isActive === true
                              ? { backgroundColor: "green" }
                              : { backgroundColor: "red" }
                          }
                        ></span>
                        <div
                          className="round_circle"
                          style={
                            item?.isActive === true
                              ? { right: "4px", transition: "2s ease-in" }
                              : { left: "4px", transition: "2s ease-in" }
                          }
                        ></div>
                      </div>
                    </label>
                    <span style={{ color: "black" }}>
                      {true ? "is Active" : "not Active"}
                    </span>
                  </div>
                </td> */}

                {/* <td>
                  <EditIcon
                    onClick={() => {
                      setModalShowButton("update", teacher);
                    }}
                    style={{ cursor: "pointer", color: "black" }}
                  />
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>

        <InAppPurchasePopup
          type="program"
          show={modalShow}
          onHide={() => setModalShow(false)}
          setModalShow={setModalShow}
          programPackageData={programPackageData}
          // comment={selectedComment}
          //   updateFunction={updateTeacherNew}
          //   updateParams={[teacher, teacher.docId]}
        />
      </div>
    </div>
  );
};

export default Product;
